var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import t from "../../I18N/t";
import { Icon } from "../../UI";

import { uploadAttachment } from "../actions/actions";

export class UploadAttachment extends Component {
  onChangeSingle(e) {
    const file = e.target.files[0];
    this.props.uploadAttachment(this.props.entity, file, { __reducerKey: this.props.storeKey });
  }

  onChangeAll(e) {
    const file = e.target.files[0];
    this.props.uploadAttachment(
    this.props.entity,
    file,
    { __reducerKey: this.props.storeKey },
    {
      allLanguages: true
    });

  }

  renderUploadButton() {
    let uploadToAll = null;

    if (this.props.languages.size > 1) {
      uploadToAll = /*#__PURE__*/
      _jsx("label", { htmlFor: "upload-attachment-all-input", className: "btn btn-success btn-xs add" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "link" }), " ", t('System', 'Add to all languages')), /*#__PURE__*/

      _jsx("input", {
        onChange: this.onChangeAll.bind(this),
        type: "file",
        id: "upload-attachment-all-input" }));



    }

    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: "upload-attachment-input", className: "btn btn-success btn-xs add" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "paperclip" }), " ", t('System', 'Add file')), /*#__PURE__*/

      _jsx("input", {
        onChange: this.onChangeSingle.bind(this),
        type: "file",
        id: "upload-attachment-input" })),


      uploadToAll));


  }

  renderProgress(progress) {
    return /*#__PURE__*/(
      _jsx("div", { className: "btn btn-default btn-disabled" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Uploading')), /*#__PURE__*/
      _jsx("span", {}, void 0, "\xA0\xA0", progress, "%")));


  }

  render() {
    const progress = this.props.progress.get(this.props.entity);
    return progress ? this.renderProgress(progress) : this.renderUploadButton();
  }
}









export function mapStateToProps({ attachments, settings }) {
  return {
    progress: attachments.progress,
    languages: settings.collection.get('languages')
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ uploadAttachment }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadAttachment);